import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withFocusable } from "wix-ui-core/dist/es/src/hocs/Focusable/FocusableHOC";
import { ThemeProviderConsumerBackwardCompatible } from '../ThemeProvider/ThemeProviderConsumerBackwardCompatible';
import AddItemLarge from 'wix-ui-icons-common/system/AddItemLarge';
import AddItemMedium from 'wix-ui-icons-common/system/AddItemMedium';
import AddItemSmall from 'wix-ui-icons-common/system/AddItemSmall';
import Add from 'wix-ui-icons-common/Add';
import Tooltip from '../Tooltip';
import Text from '../Text';
import AddMedia from 'wix-ui-icons-common/system/AddMedia';
import { dataHooks } from './constants';
import { TooltipCommonProps } from '../common/PropTypes/TooltipCommon';
import { st, classes } from './AddItem.st.css';
var AddItemButtonIcons = {
  tiny: function tiny(_ref) {
    var className = _ref.className;
    return /*#__PURE__*/React.createElement(Add, {
      className: className,
      width: "26",
      height: "26"
    });
  },
  small: AddItemSmall,
  medium: AddItemMedium,
  large: AddItemLarge,
  image: function image(_ref2) {
    var className = _ref2.className;
    return /*#__PURE__*/React.createElement(AddMedia, {
      className: className,
      width: "31",
      height: "31"
    });
  }
};

var AddItem = /*#__PURE__*/function (_Component) {
  _inherits(AddItem, _Component);

  var _super = _createSuper(AddItem);

  function AddItem() {
    var _this;

    _classCallCheck(this, AddItem);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "_renderIcon", function () {
      var _this$props = _this.props,
          size = _this$props.size,
          theme = _this$props.theme;
      var isImageIcon = theme === 'image';
      return /*#__PURE__*/React.createElement(ThemeProviderConsumerBackwardCompatible, {
        defaultIcons: {
          AddItemButton: AddItemButtonIcons
        }
      }, function (_ref3) {
        var icons = _ref3.icons;
        var Icon = icons.AddItemButton[isImageIcon ? 'image' : size];
        return /*#__PURE__*/React.createElement(Icon, {
          className: classes.icon
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "_renderText", function () {
      var _this$props2 = _this.props,
          children = _this$props2.children,
          theme = _this$props2.theme,
          size = _this$props2.size;

      if (!children || theme === 'image') {
        return null;
      }

      var textSize = size === 'tiny' ? 'small' : 'medium';
      return /*#__PURE__*/React.createElement("div", {
        className: st(classes.textWrapper, {
          size: size
        })
      }, typeof children === 'function' ? children() : /*#__PURE__*/React.createElement(Text, {
        className: classes.textContent,
        weight: "thin",
        skin: "standard",
        size: textSize,
        dataHook: dataHooks.itemText,
        ellipsis: true
      }, children));
    });

    _defineProperty(_assertThisInitialized(_this), "_renderContent", function () {
      var _this$props3 = _this.props,
          theme = _this$props3.theme,
          alignItems = _this$props3.alignItems,
          size = _this$props3.size,
          disabled = _this$props3.disabled,
          showIcon = _this$props3.showIcon,
          tooltipContent = _this$props3.tooltipContent,
          _this$props3$tooltipP = _this$props3.tooltipProps,
          tooltipProps = _this$props3$tooltipP === void 0 ? {} : _this$props3$tooltipP; // For backwards compatibility

      var content = tooltipProps.content || tooltipContent;
      var container = /*#__PURE__*/React.createElement("div", {
        className: st(classes.content, {
          theme: theme,
          size: size,
          alignItems: alignItems,
          disabled: disabled,
          tooltip: !!content
        })
      }, showIcon && _this._renderIcon(), _this._renderText());
      return theme === 'image' && !!content ? /*#__PURE__*/React.createElement(Tooltip, _extends({}, tooltipProps, {
        content: content,
        dataHook: dataHooks.itemTooltip,
        className: classes.tooltip
      }), container) : container;
    });

    return _this;
  }

  _createClass(AddItem, [{
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          dataHook = _this$props4.dataHook,
          onClick = _this$props4.onClick,
          disabled = _this$props4.disabled,
          theme = _this$props4.theme,
          focusableOnFocus = _this$props4.focusableOnFocus,
          focusableOnBlur = _this$props4.focusableOnBlur,
          removePadding = _this$props4.removePadding,
          borderRadius = _this$props4.borderRadius,
          className = _this$props4.className,
          ariaLabel = _this$props4.ariaLabel,
          ariaLabelledBy = _this$props4.ariaLabelledBy;
      return /*#__PURE__*/React.createElement("button", {
        className: st(classes.root, {
          theme: theme,
          removePadding: removePadding,
          borderRadius: borderRadius
        }, className),
        style: borderRadius && {
          borderRadius: borderRadius
        },
        "data-hook": dataHook,
        disabled: disabled,
        type: "button",
        onClick: onClick,
        onFocus: focusableOnFocus,
        onBlur: focusableOnBlur,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy
      }, this._renderContent());
    }
  }]);

  return AddItem;
}(Component);

_defineProperty(AddItem, "displayName", 'AddItem');

_defineProperty(AddItem, "propTypes", {
  /** any renderable node or a render function. In case of a render function, text styles will not be applied. */
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),

  /** apply disabled styles */
  disabled: PropTypes.bool,

  /** the theme of component */
  theme: PropTypes.oneOf(['dashes', 'plain', 'filled', 'image']),

  /** switching content alignment  */
  alignItems: PropTypes.oneOf(['center', 'right', 'left']),

  /** size to control icon and spacing  */
  size: PropTypes.oneOf(['large', 'medium', 'small', 'tiny']),

  /** click event handler  */
  onClick: PropTypes.func,

  /** Applied as data-hook HTML attribute that can be used to create driver in testing */
  dataHook: PropTypes.string,

  /** A css class to be applied to the component's root element */
  className: PropTypes.string,

  /** When provided, hover will display a tooltip - relevant only for theme `image` */
  tooltipContent: PropTypes.node,

  /** Tooltip props - relevant only for theme `image` */
  tooltipProps: PropTypes.shape(TooltipCommonProps),

  /** Displays the plus icon */
  showIcon: PropTypes.bool,

  /** Removes padding */
  removePadding: PropTypes.bool,

  /** sets the border-radius css property on the button element */
  borderRadius: PropTypes.string,

  /** Defines a string value that labels the add item element */
  ariaLabel: PropTypes.string,

  /** Identifies the element that labels the add item element */
  ariaLabelledby: PropTypes.string
});

_defineProperty(AddItem, "defaultProps", {
  theme: 'dashes',
  size: 'tiny',
  alignItems: 'center',
  showIcon: true,
  removePadding: false
});

export default withFocusable(AddItem);